import React, { useState, useEffect } from "react";
import {
  Card,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import { Button, Tooltip, useMediaQuery } from "@mui/material";
import SendIcon from "@material-ui/icons/Send";
import {
  useGetCommoditiesAllDataQuery,
  useGetCommoditiesCategoriesQuery,
  useSendcommodityDataMutation,
  useGetCommoditiesDataQuery,
  useGetIndividualUserCommodityQuery,
} from "./ProcurementApiSlice";
import { useSelector } from "react-redux";
import { selectCurrentRoles } from "features/auth/authSlice";
import swal from "sweetalert";
import IndividualUserCommodity from "./IndividualUserCommodity";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";
import AddIcon from "@mui/icons-material/Add";
import CustomSearchBar from "components/CustomSearchBar";

const CommudityMaster = ({
  setActiveCard,
  organizationVal,
  activeCard,
  user_id,
  userName,
  UserData,
  setActiveTabProject,
}) => {
  const RolesFromToken = useSelector(selectCurrentRoles);
  const [AddCommodity, setAddCommodity] = useState(false);
  const [open, setOpen] = useState("0");
  const [searchKey, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedCommodity, setSelectedCommodity] = useState([]);
  const {
    data: getCommodity,
    isFetching: isCommodityLoading,
  } = useGetCommoditiesAllDataQuery(debouncedSearch || "");
  const { data: getCommodityCategory } = useGetCommoditiesCategoriesQuery();
  const [resultedCommodity, setResultedCommodity] = useState([]);
  const [sendSelectedData] = useSendcommodityDataMutation();
  const {
    data: availableCommodity,
    refetch: refetchFilteredCommodity,
  } = useGetCommoditiesDataQuery({ user_id: user_id });
  const {
    data: IndividualUserCommodities,
    refetch: refetchIndividual,
  } = useGetIndividualUserCommodityQuery(user_id);

  // } = useGetIndividualUserCommodityQuery(RolesFromToken?.organization_id);
  const [loading, setLoading] = useState(false);
  const handleAddCommodity = (item) => {
    const isSelected = selectedCommodity?.some(
      (selectedItem) => selectedItem?.id === item?.id
    );
    if (isSelected) {
      setSelectedCommodity((prevSelected) =>
        prevSelected.filter((selectedItem) => selectedItem?.id !== item?.id)
      );
    } else {
      setSelectedCommodity((prevSelected) => [...prevSelected, item]);
    }
    setAddCommodity(true);
  };

  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  console.log("activeCrad", setActiveCard);
  const handleSubmit = () => {
    const selectedCommodityIds = selectedCommodity?.map((item) => item.code);
    const payload = {
      // user: RolesFromToken?.organization_id,
      user: user_id,
      commodities: selectedCommodityIds,
    };
    setLoading(true);
    sendSelectedData(payload)
      .unwrap()
      .then((result) => {
        if (result.status == 201) {
          Swal.fire({
            title: "Commodity Added Successfully",
            text: `${
              organizationVal?.procurement_type === "Seller"
                ? "Proceed to Manage Stock"
                : "Proceed to Initiate Trade"
            }`,
            icon: "success",
            showCancelButton: true,
            confirmButtonText: "Continue",
            cancelButtonText: "Cancel",
            confirmButtonIcon: "fas fa-arrow-right", // Add the icon you want here
          }).then((result) => {
            if (result.isConfirmed) {
              if (organizationVal?.procurement_type === "Seller") {
                setActiveCard("Manage Stocks");
                setActiveTabProject("Manage Stocks");
              } else if (organizationVal?.procurement_type === "Buyer")
                setActiveCard("Buyer Cart");
            } else {
              // User clicked 'No' or closed the dialog
            }
          });
          setAddCommodity(false);
          setLoading(false);
          refetchFilteredCommodity();
          setSelectedCommodity([]);
          refetchIndividual();
        } else {
          swal("Error", {
            buttons: false,
            icon: "warning",
            title: result.message,
            timer: 1500,
          });
          setLoading(false);
        }
      })
      .catch((data) => {
        setLoading(false);
      });
  };

  // const resultedCommodity = [];
  // getCommodityCategory?.data?.categories?.forEach((category) => {
  //   const filteredItems = getCommodity?.data?.filter(
  //     (item) => item?.category === category
  //   );
  //   if (filteredItems?.length > 0) {
  //     resultedCommodity.push({ name: category, product: filteredItems });
  //   }

  // });
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500); // 500ms debounce time

    return () => clearTimeout(handler);
  }, [searchKey]);

  useEffect(() => {
    if (!getCommodity || !getCommodityCategory) return;

    const updatedCommodityList = [];
    getCommodityCategory?.data?.categories?.forEach((category) => {
      let filteredItems = getCommodity?.data?.filter(
        (item) => item?.category === category
      );
      IndividualUserCommodities?.data?.forEach((individualCommodity) => {
        if (individualCommodity?.commodity?.category === category) {
          filteredItems = filteredItems.filter(
            (item) => item.name !== individualCommodity?.commodity?.name
          );
        }
      });

      if (filteredItems.length > 0) {
        updatedCommodityList.push({ name: category, product: filteredItems });
      }
    });

    setResultedCommodity(updatedCommodityList);
  }, [getCommodity, getCommodityCategory, IndividualUserCommodities]);

  const handleChangeSearch = (message) => {
    setSearch(message);
  };

  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        {AddCommodity === true ? (
          <span className=" m-0 mx-4 mt-3 text-gray  h5">
            SELECT COMMODITIES
          </span>
        ) : (
          <h3 className=" m-0 mx-4 mt-2"></h3>
        )}
        {AddCommodity ? (
          <Button
            variant="outlined"
            color="error"
            className="float-end  mt-3 mx-3"
            onClick={() => {
              setAddCommodity(false);
              setSelectedCommodity([]);
            }}
          >
            Cancel
          </Button>
        ) : (
          <Tooltip title="Add Commodity" arrow>
            <Button
              variant="contained"
              className="float-end buttonOrangeDefaultColor mt-2 mx-2 "
              onClick={() => {
                setAddCommodity(true);
                setSearch("");
              }}
            >
              <AddIcon />
              &nbsp;&nbsp;Add Commodity
            </Button>
          </Tooltip>
        )}
      </div>

      {AddCommodity === true ? (
        <div
          className="container p-0 p-lg-2  "
          style={{ backgroundColor: "#ebeef380" }}
        >
          <CustomSearchBar sendSearchFunction={handleChangeSearch} />
          {isCommodityLoading ? (
            <div className="text-center mt-4">
              <Spinner animation="border" />
            </div>
          ) : resultedCommodity.length === 0 ? (
            <div className="text-center mt-4">
              <h5>No Data Found</h5>
            </div>
          ) : (
            <div className="row p-0 p-lg-2 mt-lg-0 mt-2 mb-lg-0 mb-4">
              <div className={"col-lg-8"}>
                <div className="p-0 p-lg-1">
                  <Accordion
                    open={open}
                    toggle={toggle}
                    style={{
                      height: isMobile ? "350px" : "450px ",
                      overflowY: "scroll",
                    }}
                  >
                    {resultedCommodity?.map((item, index) => {
                      return (
                        <AccordionItem
                          key={index}
                          style={{ maxHeight: "100%", overflowY: "scroll" }}
                        >
                          <AccordionHeader targetId={index} className="p-2">
                            <h5 className="text-orange mt-2">
                              <b>{item.name}</b>
                            </h5>
                          </AccordionHeader>
                          <AccordionBody accordionId={index}>
                            <div className="d-flex row">
                              {item?.product?.map((item, ind) => {
                                return (
                                  <div
                                    key={ind}
                                    className={`col-12 col-sm-6 col-md-4 col-lg-3 mt-2`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleAddCommodity(item)}
                                  >
                                    <div
                                      className={`cardSample position-relative`}
                                      style={{
                                        border: selectedCommodity.some(
                                          (selectedItem) =>
                                            selectedItem?.id === item?.id
                                        )
                                          ? "1px solid orange"
                                          : "",
                                        boxShadow: selectedCommodity.some(
                                          (selectedItem) =>
                                            selectedItem?.id === item?.id
                                        )
                                          ? "rgba(0, 0, 0, 0.24) 0px 3px 8px"
                                          : "",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <div className=" d-flex p-1">
                                        <div className="col-lg-3 p-1 col-md-3 col-2">
                                          <img
                                            src={item.image_url}
                                            className=" rounded"
                                            style={{
                                              height: "40px",
                                              // width: "55px",
                                              width: "100%",
                                            }}
                                          />
                                        </div>
                                        <div className="col-lg-9 row d-flex justify-content-center align-items-center ">
                                          <span className="text-center f300">
                                            {" "}
                                            {item?.name}
                                          </span>
                                        </div>
                                        <div
                                          className="position-absolute "
                                          style={{ right: "4px" }}
                                        >
                                          <input
                                            type="checkbox"
                                            color="orange"
                                            className="bg-orange"
                                            onChange={(e) => {}}
                                            checked={
                                              selectedCommodity.some(
                                                (selectedItem) =>
                                                  selectedItem?.id === item?.id
                                              )
                                                ? true
                                                : false
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </AccordionBody>
                        </AccordionItem>
                      );
                    })}
                  </Accordion>
                </div>
              </div>
              <div className="col-lg-4 position-relative">
                <h5 className="text-orange mb-lg-2 mb-0 mt-lg-0 mt-2">
                  SELECTED COMMODITY
                </h5>
                {selectedCommodity?.length > 0 ? (
                  <div className="" style={{ backgroundColor: "#ffffff" }}>
                    <div
                      className="p-2 row"
                      style={{ maxHeight: "100%", overflowY: "scroll" }}
                    >
                      {selectedCommodity?.map((item, ind) => {
                        return (
                          <div
                            key={ind}
                            className={`col-md-6 col-12 mb-3  `}
                            style={{ cursor: "pointer" }}
                          >
                            <div className={`cardSample mb-1`}>
                              <div className="row p-1">
                                <div className="col-lg-3 p-1 col-3">
                                  <img
                                    src={item?.image_url}
                                    className="rounded img-fluid"
                                    style={{ width: "40px", height: "40px" }}
                                  />
                                </div>
                                <div className="col-8 d-flex justify-content-center align-items-center mt-1">
                                  <span className="text-center f300">
                                    {" "}
                                    {item?.name}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="d-flex justify-content-center align-items-center w-100">
                      <Button
                        variant="contained"
                        className="buttonOrangeDefaultColor mt-2 mx-2 mb-3 "
                        onClick={handleSubmit}
                        disabled={selectedCommodity?.length > 0 ? false : true}
                      >
                        Submit &nbsp;
                        <SendIcon fontSize="small" color="" className="m-0" />
                        {loading ? <Spinner size="sm" /> : ""}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <Card className="shadow-sm border-0">
                    <div className="p-4 text-center">
                      <h5 className="mt-2 mb-3 font-weight-bold">
                        Select Commodity to Add
                        <span
                          className="mdi mdi-file-plus ms-2"
                          style={{ fontSize: "1.2rem" }}
                        ></span>
                      </h5>
                      <p className="text-muted mb-4">
                        You currently do not have any selected commodities.
                        Please click on the list to select a commodity to add to
                        your inventory.
                      </p>
                      <div className="alert alert-info" role="alert">
                        <strong>Tip:</strong> Make sure to review the details of
                        the commodity before adding it to ensure it meets your
                        requirements.
                      </div>
                    </div>
                  </Card>
                )}
              </div>
            </div>
          )}
        </div>
      ) : (
        <IndividualUserCommodity
          organizationVal={organizationVal}
          user_id={user_id}
          availableCommodity={availableCommodity}
          userName={userName}
          UserData={UserData}
          setActiveCard={setActiveCard}
          activeCard={activeCard}
          refetchFilteredCommodity={refetchFilteredCommodity}
        />
      )}
    </div>
  );
};

export default CommudityMaster;
